import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { FormikField } from '../../../../../Formik'
import { InputField } from '../../../../../Input'
import { USER_FORM_EMAIL_FIELD_MAX_LENGTH } from '../../../../../User'
import { APPLICANT_FORM_FIELD_NAME_EMAIL } from '../../RentalPortalApplicantForm.constants'

function EmailField({ fieldRef }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      elementRef={fieldRef}
      fieldComponentProps={{
        label: `${t('Inhabitant.EmailLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_EMAIL_FIELD_MAX_LENGTH}
      name={APPLICANT_FORM_FIELD_NAME_EMAIL}
      placeholder={t('Inhabitant.EmailPlaceholderKey')}
    />
  )
}

export default EmailField
